import React from 'react';
import { ParentAdminsController } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/ParentAdminsController';
import { useCanAccessParentAdminFlows } from './hooks/useCanAccessParentAdminFlows/useCanAccessParentAdminFlows';

export const ParentAdmins: React.FC = () => {
  const isUserAllowedAccess = useCanAccessParentAdminFlows();

  if (!isUserAllowedAccess) {
    return null;
  }

  return <ParentAdminsController />;
};
